export default __webpack_public_path__ + "static/media/xfinity-black.bf81aa72.svg";